import { render, staticRenderFns } from "./stdrate.vue?vue&type=template&id=b3d965cc"
import script from "./stdrate.vue?vue&type=script&lang=js"
export * from "./stdrate.vue?vue&type=script&lang=js"
import style0 from "./stdrate.vue?vue&type=style&index=0&id=b3d965cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports